var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-container"}},[_c('loading-bar'),_c('transition',{attrs:{"name":"layout","mode":"out-in"}},[_c(_vm.layout,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }